export enum TournamentBankrollType {
    FIXED = 'fixed',
    TOTAL_BET_PERCENTS = 'total_bet_percents',
    BOTH = 'both',
}